import { Container } from "react-bootstrap";
import styled from "styled-components";

/** Matches header / About page horizontal alignment (Bootstrap Container). */
export const PageContainer = styled(Container)``;
